// extracted by mini-css-extract-plugin
export default {"card":"j3-z"};